import classNames from "classnames"

export const FourOhFour = () => {
    return (
        <div className="f-pg">
            <div className={classNames("flx-c", "f-pg")}>
                <h1>Error 404</h1>
                <h5>Page not found</h5>
            </div>
        </div>
    )
}